import React, { Dispatch, SetStateAction } from 'react';

interface CommentsSectionContextType {
  postId: string | null;
  comments: WordpressComment[];
  reloadComments: () => void;
  setParentCommentId: Dispatch<SetStateAction<null>>;
  parentCommentId: string | null;
}

const defaultValues: CommentsSectionContextType = {
  postId: null,
  comments: [],
  reloadComments: () => {},
  setParentCommentId: () => {},
  parentCommentId: null,
};

export const CommentsSectionContext =
  React.createContext<CommentsSectionContextType>(defaultValues);

export const useCommentsSectionContext = () =>
  React.useContext(CommentsSectionContext);
